"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bundleSpecs = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_core_1 = require("@patternfly/react-core");
exports.bundleSpecs = {
    virtualization: {
        noSNO: true,
        Description: () => (React.createElement(react_core_1.List, null,
            React.createElement(react_core_1.ListItem, null, "Enabled CPU virtualization support in BIOS (Intel-VT / AMD-V) on all nodes."),
            React.createElement(react_core_1.ListItem, null, "Each control plane node requires an additional 1024 MiB of memory and 3 CPU cores."),
            React.createElement(react_core_1.ListItem, null, "Each worker node requires an additional 1024 MiB of memory and 5 CPU cores."),
            React.createElement(react_core_1.ListItem, null, "Additional resources may be required to support the selected storage operator."))),
    },
    'openshift-ai': {
        noSNO: true,
        incompatibleBundles: [],
        Description: () => (React.createElement(react_core_1.List, null,
            React.createElement(react_core_1.ListItem, null, "NVIDIA GPU, AMD GPU and Kernel Module Management may or may not be installed based on the GPU discovered on your hosts."))),
    },
};
//# sourceMappingURL=bundleSpecs.js.map